module.exports = __webpack_public_path__ + "img/icon-yes.88e2dc3c.svg";